import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import SalesByClientForm from "@components/dynamic/SalesByClientForm ";

const SalesByClientReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Historial de Ventas por Cliente"
      backUrl="/user/dashboard-inventory"
    >
      <SalesByClientForm />
    </PageContainer >
  );
}

export default SalesByClientReport;
